declare const __APP_VERSION__: string;

const env = import.meta.env;

export const config = {
  debug: env.VITE_DEBUG === 'true',
  apiUrl: env.VITE_API_URL,
  sentryDsn: env.VITE_SENTRY_DSN as string | undefined,
  sentryEnvironment: env.VITE_SENTRY_ENVIRONMENT as string | undefined,
  environment: (env.VITE_SENTRY_ENVIRONMENT as string | undefined) || env.MODE,
  appVersion: __APP_VERSION__,
  auth0: {
    domain: env.VITE_AUTH0_DOMAIN,
    clientId: env.VITE_AUTH0_CLIENT_ID,
    audience: env.VITE_AUTH0_AUDIENCE,
    guestClientId: env.VITE_AUTH0_GUEST_CLIENT_ID,
    // Dev only: tokens survive a reload, so no re-login (silent sign-in needs third-party cookies).
    cacheLocation: env.DEV ? ('localstorage' as const) : ('memory' as const),
    claimsNamespace: env.VITE_AUTH0_CLAIMS_NAMESPACE
  },
  googleMaps: {
    apiKey: env.VITE_GOOGLE_MAPS_API_KEY
  },
  features: {
    /** When true, users can enter a custom NIS amount when initiating payment (instead of fixed 7%) */
    allowCustomPaymentAmount: env.VITE_ALLOW_CUSTOM_PAYMENT_AMOUNT === 'true',
    /** When true, the language switcher is shown in the sidebar footer */
    enableLanguageSwitcher: env.VITE_ENABLE_LANGUAGE_SWITCHER === 'true'
  }
} as const;
